export default {
  title: 'Connections',
  newConnection: 'New connection',
  createNewConnection: 'Create a new connection',
  emptyState: "You don't have any connections yet",
  createYourFirstConnection: 'Create your first connection',
  connectionsCount: '{count, plural, =1 {1 connection} other {# connections}}',
  connectionsCountSearching: '{count, plural, =1 {1 results} other {# results}} by "{search}"',
  connectionsCountSearchingBookmarks: '{count, plural, =1 {1 starred result} other {# starred results}} by "{search}"',
  filters: {
    search: 'Search connections'
  },
  connectionsListBanner: {
    title: 'Connect your Data Warehouse',
    prompt: 'Connect your Data Warehouse and seamlessly interact with your data.',
    content:
      'Select your provider, enter the connection details, and start using the CARTO platform with your data warehouse.',
    providers: {
      googleBigQuery: 'Google Big Query',
      snowflake: 'Snowflake',
      postgresql: 'PostgreSQL',
      amazonRedshift: 'Amazon Redshift',
      databricksRest: 'Databricks (Legacy)',
      databricksWarehouse: 'Databricks',
      andMore: 'And more to come...'
    }
  },
  cards: {
    spatialExtension: {
      title: 'Spatial Extension',
      enabled: 'Enabled',
      disabled: 'Disabled',
      notAvailable: 'Coming soon',
      activation: 'Spatial extension activation',
      notAvailableDescription: 'This feature will be available soon.',
      availableDescription:
        'By activating this option the {spatialExtensionLink} and your {dataObservatoryLink} subscriptions will be available from this connection.',
      analyticsToolbox: 'CARTO Analytics Toolbox',
      available: 'Available',
      updateAvailable: 'Update available',
      unavailable: 'Unavailable',
      installNow: 'Install now',
      analyticsToolboxAvailable: 'Learn more about Available status (New tab)',
      analyticsToolboxUnavailable: 'Learn more about Unavailable status (New tab)',
      updateStatus: 'Refresh status',
      learnMore: 'Learn more',
      viewDoc: 'Visit documentation',
      contactAdminTooltip:
        'Contact the Admin user of your CARTO organization to {action} the Analytics Toolbox for {provider}',
      requiresManualInstallation: 'Requires manual installation'
    },
    cartoDW: {
      storage: 'Storage',
      unlimited: 'Unlimited',
      computing: 'Computing',
      computingValue: '{size}TB / day',
      features: 'Features',
      banner: {
        pretitle: 'Connection',
        title: 'CARTO Data Warehouse',
        info: 'Every CARTO organization includes a <b>scalable cloud Data Warehouse</b> by default, and in the same region.',
        infoNew:
          'Every CARTO organization includes a scalable cloud Data Warehouse by default, and in the same region.',
        infoLink: 'Learn more',
        connectionTitle: 'Connection name'
      },
      limits: {
        storage: 'Storage',
        computing: 'Computing',
        maps: 'Maps created',
        storageSize: '10GB',
        acceleration: 'Acceleration',
        accelerationSize: '1GB'
      },
      consoleAccess: {
        title: 'Console access',
        getAccessText:
          'Get access to the CARTO Data Warehouse console to add, manage, rename or update your tables and tilesets.',
        getAccess: 'Get access',
        accessConsole: 'Access console',
        docLink: 'How to use this feature',
        getAcccessSucces: 'Successfully added CARTO Data Warehouse grant.',
        getAcccessError: 'Failed to add CARTO Data Warehouse grant.',

        getAccessDialog: {
          title: 'Get console access',
          message:
            'The CARTO Data Warehouse is powered by Google Cloud Platform. Please, tell us which Google account do you want to use to access the console.',
          emailLabel: 'Google Account',
          invalidEmail: `Make sure it's a valid email`,
          invalidAccountNotGoogle: `It seems that this email is not associated with a Google account. Please review and try again (no email aliases allowed).`,
          successMessage: 'Successfully added CARTO Data Warehouse grant.'
        },
        revokeAccessDialog: {
          title: 'Remove console access',
          message: 'You can restore access with another Google account at any time.',
          successMessage: 'Successfully removed CARTO Data Warehouse grant.',
          errorMessage: 'Failed to remove CARTO Data Warehouse grant.'
        }
      }
    },
    tooltips: {
      maps: 'Maps created'
    },
    editDialog: {
      title: 'Save changes',
      description: 'Are you sure that you want to make changes to the {provider} connection {name}?',
      errorMessage: "We couldn't save the changes, please try again",
      edit: 'Yes, save',
      warning: {
        title: 'Making changes in this connection could affect:'
      }
    },
    viewDialog: {
      title: 'Connection details'
    },
    deleteDialog: {
      title: 'Delete connection',
      descriptionWithTransfer:
        'Are you sure you want to delete the {provider} connection {name}? This action cannot be undone. You must decide what to do with the maps, workflows, tokens, etc. that depend on it:',
      description: 'Are you sure you want to delete the {provider} connection {name}? This action cannot be undone',
      errorMessage: "We couldn't delete the connection, please try again",
      successMessage: 'Connection deleted successfully',
      error409Message:
        "This connection can't be deleted because it's still used in maps created by other users in your organization. Please contact other map owners so they remove this connection from their maps.",
      cantDeleteMessage: "This connection can't be deleted. Contact your organization Admin to remove it.",
      yesDelete: 'Yes, delete',
      transferOption: 'Update maps, workflows, tokens, etc. to use another connection',
      deleteOption: 'Delete maps, workflows, tokens, etc. along with the connection',
      mapsCount: '{count, plural, =1 {# map} other {# maps}}',
      workflowsCount: '{count, plural, =1 {# workflow} other {# workflows}}',
      warning: {
        title: 'Deleting this connection will also delete:',
        message:
          '{maps, plural, =0 {} =1 {# map} other {# maps}} {showAnd, plural, =0 {} other {and}} {workflows, plural, =0 {} =1 {# workflow} other {# workflows}}'
      }
    },
    transferDialog: {
      title: 'Transfer assets and delete connection',
      description:
        'Transfer all assets (maps, workflows, datasets) from the {provider} connection {name} to another connection of the same type, then delete the original connection.',
      selectConnection: 'Select a new connection:',
      searchPlaceholder: 'Search for a {dataWarehouse} connection...',
      targetConnection: 'Target connection:',
      deleteWithTransfer: 'Transfer & Delete',
      successMessage: 'Connection deleted successfully',
      noAvailableConnections: {
        title: 'No other {provider} connection found',
        description:
          'You need to own at least one other {provider} connection to update maps, workflows, tokens, etc. before deletion.'
      },
      onlySameProvider: 'You can only choose among existing connections of the same provider.',
      warningTitle: 'Make sure the new connection is compatible',
      warning: `Updated maps, workflows, tokens, etc. may have errors if the new connection doesn't have the same tables and structure.`
    }
  },
  create: {
    common: {
      title: 'Connect your data',
      titleEdit: 'Edit connection',
      updateSuccess: 'Changes successfully saved.',
      warehouse: 'Data warehouse',
      selectWarehouse: 'Select data warehouse',
      success: 'Connection successfully created',
      connect: 'Connect',
      edit: 'Save changes',
      tryAgain: 'Try again',
      configureCredentials: 'Setup connection',
      usingUsernamePassword: 'Connect using username/password',
      or: 'or',
      empty: 'Select a data warehouse above to configure a connection',
      canNotCreate: `Your current role doesn't allow creating connections. Talk to your organization admin.`,
      connectionName: {
        error:
          "A connection name should be 3-50 characters long, containing only lowercase letters and numbers. Dashes and underscores are allowed if they're not leading or tailing."
      },
      requestConnector: 'Looking for another data warehouse?',
      moreConnectorsAvailableSoon: 'More connectors available soon',
      requestFabricConnector: 'Fabric',
      requestConnectorAsk: 'Contact us',
      askUs: 'Ask us',
      beta: 'Beta',
      sharingOptions: 'Sharing options',
      permissionsAndSharing: 'Permissions and sharing',
      change: 'Change',
      manageOption: 'Manage option',
      alwaysPrivateForOauth: "Connection using OAuth (linked to personal accounts) can't be shared"
    },
    databricksRest: {
      infoTitle: 'Connect to your Databricks database',
      infoDescription:
        'CARTO can connect to a Databricks SQL Warehouse to push down SQL queries and to a Databricks cluster to create and run jobs.',
      requestExplicitEnablement:
        'Databricks currently lacks official generic Spatial SQL support. We’re actively working to establish this. Meanwhile, we’re evaluating and exploring options to enable vector, raster and H3 support. Please {letUsKnow} if you need this connection enabled.',
      documentation: 'Databricks documentation',
      back: 'Back to Databricks info',
      oauth: {
        error: 'Something went wrong. Please complete the OAuth flow again to make this connection available.'
      },
      connectUsingOAuth: 'Connect using OAuth',
      personalAccessToken: 'Connect using personal access token',
      m2m: 'Setup connection with OAuth M2M',
      u2m: 'Setup connection with OAuth U2M',
      alertInfoU2m: {
        title: 'Looking to connect using OAuth U2M?',
        descriptionAdmin:
          'To avoid using usernames and passwords, CARTO can also connect to Databricks via OAuth User To Machine (U2M). Set up an integration U2M and enable that connection method for all users.',
        descriptionEditor:
          'To avoid using usernames and passwords, CARTO can also connect to Databricks via OAuth User To Machine (U2M). Please contact your CARTO admin so they set it up.',
        button: 'Go to Integrations'
      },
      form: {
        connectionNameLabel: 'Name',
        connectionNamePlaceholder: 'Type a name for your connection',
        hostLabel: 'Host',
        hostPlaceholder: 'E.g.: carto-data-science.cloud.databricks.com',
        catalogLabel: 'Catalog',
        connectedDatabricksUser: 'Connected Databricks user',
        catalogPlaceholder: {
          waitingForCredentials: 'Enter workspace name and token to get the available catalogs',
          waitingForCredentialsU2M: 'Enter host and connected Databricks user to get the available catalogs',
          waitingForCredentialsM2M:
            'Enter host, service principal client ID and service principal secret to get the available catalogs',
          loading: '... getting the available catalogs',
          error: 'Authorization failed: check the workspace name and token to get the available catalogs',
          empty: 'No suitable catalogs available for entered credentials',
          available: 'Select a Catalog'
        },
        catalogErrorHelperText: {
          m2m: "Couldn't retrieve catalogs. Check your M2M credentials and ensure there are catalogs available.",
          u2m: 'No catalogs were returned. Please try again.'
        },
        connectionTypeLabel: 'OAuth type',
        emailLabel: 'Email',
        servicePrincipalClientIdLabel: 'Service Principal Client ID',
        servicePrincipalClientIdPlaceholder: 'E.g.: fd045d54-4289-42d9-b21b-05c700efb51f',
        servicePrincipalSecretLabel: 'Service Principal Secret',
        servicePrincipalSecretPlaceholder: 'E.g.: dosed19f972138a039663c74a75bc8c6dcda',
        warehouseIdLabel: 'Warehouse',
        warehouseIdPlaceholder: 'Type your Warehouse ID',
        tokenLabel: 'Token',
        tokenPlaceholder: 'Type your Databricks personal token',
        clusterLabel: 'All-purpose compute',
        clusterPlaceholder: {
          waitingForCredentials: 'Enter credentials to get the available compute clusters',
          waitingForCredentialsU2M: 'Enter host and connected Databricks user to get the available compute clusters',
          waitingForCredentialsM2M:
            'Enter host, service principal client ID and service principal secret to get the available compute clusters',
          loading: '... getting the available compute',
          error: 'Authorization failed: check the workspace name and token to get the available computes',
          empty: 'No compute clusters available',
          available: 'Select an All-purpose compute'
        },
        clusterErrorHelperText: {
          m2m: 'No photon-enabled compute clusters were returned. Make sure at least one is active in Databricks.',
          u2m: 'No photon-enabled compute clusters were returned. Make sure at least one is active in Databricks.'
        },
        warehouseLabel: 'SQL Warehouse',
        warehousePlaceholder: {
          waitingForCredentials: 'Enter workspace name and token to get the available SQL Warehouses',
          waitingForCredentialsU2M: 'No warehouses available',
          waitingForCredentialsM2M:
            'Enter host, service principal client ID and service principal secret to get the available warehouses',
          loading: '... getting the available SQL Warehouses',
          error: 'Authorization failed: check the workspace name and token to get the available SQL warehouses',
          empty: 'No suitable SQL warehouses available for entered credentials',
          available: 'Select a SQL warehouse'
        },
        warehouseErrorHelperText: {
          m2m: 'No active SQL Warehouses were returned. Make sure at least one is active in Databricks.',
          u2m: 'No active SQL Warehouses were returned. Make sure at least one is active in Databricks.'
        },
        warningAlert: {
          title: 'Connecting to Databricks',
          titleM2M: 'Connecting to Databricks M2M',
          titleU2M: 'Connecting to Databricks U2M',
          content: {
            1: 'Connections are only supported in Photon-enabled clusters (with Databricks Runtime 11.2 or above) and Databricks SQL endpoints at the DBSQL Pro/Serverless tiers.',
            2: 'Working with geometries is only supported when connecting to a Databricks cluster and it requires the installation of the com.carto.analyticstoolbox.core library (in Beta). Check out <a>the instructions</a> in our documentation.'
          },
          checkboxLabel: 'Got it!'
        }
      }
    },
    databricksWarehouse: {
      infoTitle: 'Connect to your Databricks SQL Warehouse',
      infoDescription:
        'CARTO can connect to a Databricks SQL Warehouse for efficient data warehouse operations and analytics.',
      documentation: 'Databricks documentation',
      back: 'Back to Databricks info',
      personalAccessToken: 'Connect using personal access token',
      m2m: 'Setup connection with OAuth M2M',
      u2m: 'Setup connection with OAuth U2M',
      alertInfoU2m: {
        title: 'Looking to connect using OAuth U2M?',
        descriptionAdmin:
          'To avoid using usernames and passwords, CARTO can also connect to Databricks via OAuth User To Machine (U2M). Set up an integration U2M and enable that connection method for all users.',
        descriptionEditor:
          'To avoid using usernames and passwords, CARTO can also connect to Databricks via OAuth User To Machine (U2M). Please contact your CARTO admin so they set it up.',
        button: 'Go to Integrations'
      },
      connectUsingOAuth: 'Connect using OAuth',
      form: {
        connectionNameLabel: 'Name',
        connectionNamePlaceholder: 'Type a name for your connection',
        hostLabel: 'Host',
        hostPlaceholder: 'E.g.: carto-data-science.cloud.databricks.com',
        schemaLabel: 'Default schema (optional)',
        schemaDetailsLabel: 'Default schema',
        schemaPlaceholder: 'default',
        schemaError: 'Only letters, numbers, underscores and hyphens are allowed',
        stagingVolumeLabel: 'Import staging volume (optional)',
        stagingVolumeDetailsLabel: 'Import staging volume',
        stagingVolumePlaceholder: 'catalog.schema.volume',
        stagingVolumeError: 'Expected format: catalog.schema.volume',
        catalogLabel: 'Catalog',
        connectedDatabricksUser: 'Connected Databricks user',
        catalogPlaceholder: {
          waitingForCredentials: 'Enter host and token to get the available catalogs',
          waitingForCredentialsU2M: 'Enter host and connected Databricks user to get the available catalogs',
          waitingForCredentialsM2M:
            'Enter host, service principal client ID and service principal secret to get the available catalogs',
          loading: '... getting the available catalogs',
          error: 'Authorization failed: check the host and token to get the available catalogs',
          empty: 'No suitable catalogs available for entered credentials',
          available: 'Select a Catalog'
        },
        clusterPlaceholder: {
          waitingForCredentials: 'Enter credentials to get the available compute clusters',
          loading: '... getting the available compute',
          error: 'Authorization failed: check the workspace name and token to get the available computes',
          empty: 'No compute clusters available',
          available: 'Select an All-purpose compute'
        },
        catalogErrorHelperText: {
          m2m: "Couldn't retrieve catalogs. Check your M2M credentials and ensure there are catalogs available.",
          u2m: 'No catalogs were returned. Please try again.'
        },
        connectionTypeLabel: 'OAuth type',
        emailLabel: 'Email',
        servicePrincipalClientIdLabel: 'Service Principal Client ID',
        servicePrincipalClientIdPlaceholder: 'E.g.: fd045d54-4289-42d9-b21b-05c700efb51f',
        servicePrincipalSecretLabel: 'Service Principal Secret',
        servicePrincipalSecretPlaceholder: 'E.g.: dosed19f972138a039663c74a75bc8c6dcda',
        warehouseIdLabel: 'Warehouse',
        warehouseIdPlaceholder: 'Type your Warehouse ID',
        tokenLabel: 'Token',
        tokenPlaceholder: 'Type your Databricks personal token',
        clusterLabel: 'All-purpose compute',
        clusterIdLabel: 'Cluster ID',
        warehouseLabel: 'SQL Warehouse',
        warehousePlaceholder: {
          waitingForCredentials: 'Enter host and token to get the available SQL Warehouses',
          waitingForCredentialsU2M: 'Enter host and connect user to get the available SQL Warehouses',
          waitingForCredentialsM2M:
            'Enter host, service principal client ID and service principal secret to get the available warehouses',
          loading: '... getting the available SQL Warehouses',
          error: 'Authorization failed: check the host and token to get the available SQL warehouses',
          empty: 'No suitable SQL warehouses available for entered credentials',
          available: 'Select a SQL warehouse'
        },
        warehouseErrorHelperText: {
          m2m: 'No active SQL Warehouses were returned. Make sure at least one is active in Databricks.',
          u2m: 'No active SQL Warehouses were returned. Make sure at least one is active in Databricks.'
        },
        warningAlert: {
          title: 'Connecting to Databricks',
          titleM2M: 'Connecting to Databricks M2M',
          titleU2M: 'Connecting to Databricks U2M',
          content: {
            1: 'Connections are supported in Databricks SQL Warehouses at the DBSQL Pro/Serverless tiers.'
          },
          checkboxLabel: 'Got it!'
        }
      }
    },
    postgres: {
      infoTitle: 'Connect to your PostgreSQL database',
      infoDescription:
        'Use CARTO with your data in a PostgreSQL-compatible database, including Google Cloud SQL, Amazon Aurora & RDS and Azure Database for PostgreSQL',
      documentation: 'PostgresSQL documentation',
      back: 'Back to PostgreSQL info',
      form: {
        connectionNameLabel: 'Name',
        connectionNamePlaceholder: 'Type a name for your connection',
        serverLabel: 'Server',
        serverPlaceholder: 'Type your server DNS name or IP address',
        databaseLabel: 'Database',
        databasePlaceholder: 'Type your database name',
        usernameLabel: 'Username',
        usernamePlaceholder: 'Type your username',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Type your password',
        portLabel: 'Port',
        portPlaceholder: 'Type your port'
      }
    },
    redshift: {
      infoTitle: 'Connect to your Redshift cluster',
      infoDescription: 'Use CARTO with your data in an Amazon Redshift data warehouse',
      documentation: 'Redshift documentation',
      back: 'Back to Redshift info',
      form: {
        connectionNameLabel: 'Name',
        connectionNamePlaceholder: 'Type a name for your connection',
        clusterLabel: 'Cluster',
        clusterPlaceholder: 'Type your cluster name',
        databaseLabel: 'Database',
        databasePlaceholder: 'Type your database name',
        usernameLabel: 'Username',
        usernamePlaceholder: 'Type your username',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Type your password',
        portLabel: 'Port',
        portPlaceholder: 'Type your port'
      }
    },
    snowflake: {
      infoTitle: 'Connect to your Snowflake account',
      infoDescription: 'Use CARTO with your data in a Snowflake data warehouse',
      documentation: 'Snowflake documentation',
      back: 'Back to Snowflake info',
      lookingOAuth: 'Looking to connect using OAuth?',
      oAuthAdminDescription:
        'To avoid using usernames and passwords, CARTO can also connect to Snowflake via OAuth and External OAuth. Set up an integration and enable that connection method for all users.',
      oAuthEditorDescription:
        'To avoid using usernames and passwords, CARTO can also connect to Snowflake via OAuth and External OAuth. Please contact your CARTO admin so they set it up.',
      goToIntegrations: 'Go to Integrations',
      setupWithOAuth: 'Setup connection with OAuth',
      connectUsingOAuth: 'Connect using OAuth',
      connectUsingKeyPair: 'Connect using Key Pair',
      signInToSnowflake: 'Sign in to Snowflake',
      roleDialog: {
        title: 'What role should CARTO use?',
        description: 'Specify a role to use with this connection, or leave empty to use the default role.'
      },
      form: {
        connectionNameLabel: 'Name',
        connectionNamePlaceholder: 'sfconn',
        accountLabel: 'Account identifier or account URL',
        accountLabelInfo:
          'Your Snowflake account identifier or full account URL (e.g. https://abc12345.us-east-1.snowflakecomputing.com)',
        accountPlaceholder: 'abc12345.us-east-1',
        privateKey: 'Private key',
        privateKeyEndingIn: 'Private key ending in ',
        privateKeyPlaceholder: '-----BEGIN PRIVATE KEY----- \n\n MIIE6T... \n\n -----END PRIVATE KEY-----',
        privateKeyPassphrase: 'Private key passphrase',
        privateKeyPassphrasePlaceholder: 'Type your passphrase',
        changePrivateKeyButton: 'Change private key',
        databaseLabel: 'Database',
        databasePlaceholder: 'DEMO_DB',
        usernameLabel: 'Username',
        usernamePlaceholder: 'MYUSERNAME',
        passwordLabel: 'Password',
        passwordPlaceholder: '••••••••••••••',
        warehouseLabel: 'Warehouse',
        warehousePlaceholder: 'COMPUTE_WH',
        roleLabel: 'Role',
        rolePlaceholder: 'PUBLIC',
        connectedSnowflakeUser: 'Connected Snowflake user'
      },
      oauth: {
        error: 'Something went wrong. Please complete the OAuth flow again to make this connection available.'
      }
    },
    oracle: {
      infoTitle: 'Connect to Oracle',
      infoDescription: 'Connect to your Oracle database using a wallet file for secure authentication.',
      documentation: 'Oracle documentation',
      back: 'Back to Oracle info',
      form: {
        walletFileLabel: 'Wallet File (ZIP)',
        connectionStringLabel: 'Connection String',
        connectionStringPlaceholder: 'Enter your Oracle connection string',
        connectionStringHelp: 'The connection string from your tnsnames.ora file',
        userLabel: 'Username',
        userPlaceholder: 'Enter your Oracle username',
        passwordLabel: 'Password',
        passwordPlaceholder: 'Enter your password',
        walletPasswordLabel: 'Wallet Password',
        walletPasswordPlaceholder: 'Enter your wallet password',
        walletPasswordHelp: 'The password for your wallet file',
        changeWalletButton: 'Change wallet',
        tempLocationLabel: 'CARTO temp. location',
        tempLocationPlaceholder: 'CARTO_TEMP',
        tempLocationHelp:
          'CARTO Workflows stores temporary tables in your database. By default they are created in the CARTO_TEMP schema. To use a different location, enter a schema name.',
        workspaceLocationLabel: 'CARTO Workspace location',
        workspaceLocationPlaceholder: 'CARTO_WORKSPACE',
        workspaceLocationHelp:
          'CARTO Workflows stores non-temporary resources, such as stored procedures, in your database. By default they are created in the CARTO_WORKSPACE schema. To use a different location, enter a schema name.',
        extensionsLocationLabel: 'CARTO Extensions location',
        extensionsLocationPlaceholder: 'CARTO_EXTENSIONS',
        extensionsLocationHelp:
          'CARTO uses this location to store shared Extension Package resources. By default they are created in the CARTO_EXTENSIONS schema. To use a different location, enter a schema name.',
        locationsCreateUserInfo:
          'CARTO will try to create a user with no authentication (a schema-only account) for these locations. This operation requires the CREATE USER privilege.'
      }
    },
    bigquery: {
      infoTitle: 'Connect to your BigQuery projects',
      googleMsg:
        'CARTO’s use and transfer to any other app of information received from Google APIs will adhere to {googleLink}, including the Limited Use requirements.',
      googleLink: 'Google API Services User Data Policy',
      infoDescription:
        'CARTO seamlessly connects to BigQuery to enable geospatial analytics and high-performance data visualizations.',
      infoLink: 'We call this the {linkText}',
      infoLinkText: 'CARTO Analytics Toolbox for BigQuery.',
      documentation: 'BigQuery documentation',
      configureWithWIF: 'With Workload Identity Federation',
      configureCredentials: 'With a service account',
      connectUsingGoogle: 'Connecting with Google',
      continueWithGoogle: 'Continue with Google',
      back: 'Back to BigQuery info',
      next: 'Next',
      oauth: {
        googleAccount: 'Connected Google account',
        error: 'Something went wrong. Please sign up again with your Google account to make this connection available.'
      },
      workloadIdentity: {
        emailAliasInCard: 'Workload Identity',
        info: {
          title: 'Looking to connect using Workload Identity Federation?',
          message:
            'CARTO and BigQuery can also be connected via Workload Identity Federation. This allows your BigQuery administrators to grant granular permissions to users in CARTO without having to upload and manage service accounts.',
          messageEditor:
            'CARTO and BigQuery can also be connected via Workload Identity Federation. This allows your BigQuery administrators to grant granular permissions to users in CARTO without having to upload and manage service accounts. Please contact your CARTO admin so they set it up.'
        }
      },
      check: {
        description: 'CARTO will connect to your data in BigQuery with the authentication method selected above.',
        parameter: ''
      },
      googleApiServices: {
        description:
          "CARTO's use and transfer to any other app of information received from Google APIs will adhere to <link>Google API Services User Data Policy</link>, including the Limited Use requirements."
      },
      help: {
        description:
          'For more detailed information on CARTO usage limits and BigQuery, <link>check out our documentation area.</link>'
      },
      info: {
        1: {
          description: 'The GCP account used for the connection should be granted a set of predefined BigQuery roles.',
          parameter: 'BigQuery roles'
        },
        2: {
          description:
            'BigQuery User and BigQuery Data Editor are needed to list datasets and tables in your projects, run queries and create maps from your data'
        },
        3: {
          description:
            'Our recommendation is to configure specific limits in BigQuery to avoid any unexpected processing charges.'
        }
      },
      terms: {
        text: {
          1: 'CARTO makes use of a set of custom functions available in BigQuery. We call this the {cse}.',
          2: 'Please ensure that the email address you use for your CARTO and Google BigQuery accounts are the same.',
          3: 'We will use your {googleEmail} to grant access to the Spatial Extension from the BigQuery Console. We will also use a {googleSA} for other operations such as listing the tilesets stored in your project’s datasets, publishing and unpublishing tilesets for public visualizations.',
          4: 'Our recommendation is to configure specific limits in BigQuery to avoid any unexpected processing charges. For more detailed information on CARTO usage limits and BigQuery, check out our {docs} area.',
          cse: 'Carto Spatial Extension for BigQuery',
          googleEmail: 'Google Account Email',
          googleSA: 'Google Cloud service account',
          docs: 'documentation'
        }
      },
      form: {
        connectionNameLabel: 'Name',
        connectionNamePlaceholder: 'Type a name for your connection',
        clientEmailLabel: 'Email',
        audienceLabel: 'Audience',
        billingProjectIdLabel: 'Billing Project ID'
      },
      serviceAccount: {
        title: 'Service account key',
        placeholder: 'Upload your JSON file',
        error: 'The provided service account is not valid',
        permissionsError:
          'There seems to be an issue with the service account provided. It might be missing the required permissions. Please check the documentation to ensure that you have provided them correctly.',

        reUpload: 'Upload a different service account',
        help: {
          text: 'Upload a service account key in JSON format.',
          expand: 'More info',
          collapse: 'Collapse'
        },
        text: {
          1: 'Upload a service account key in {json} format. Get help creating and managing Google Cloud service accounts {here}.',
          2: 'We will use this service account to list tables and datasets in your projects, run queries and create maps from your data. Be sure that the service account has {bqDataEditor} and {bqJobUser} predefined roles.',
          3: 'Read our {docs} if you want to learn about the specific permissions that CARTO requires.',
          json: 'JSON',
          here: 'here',
          bqDataEditor: 'BigQuery Data Editor',
          bqJobUser: 'BigQuery Job User',
          docs: 'documentation'
        }
      },
      iamPrincipal: {
        label: 'IAM Principal',
        helperText: 'Use this IAM Principal to manage permissions to this connection in GCP.'
      },
      serviceAccountEmail: {
        label: 'Service Account email for impersonation',
        placeholder: 'Type the email of the Service Account you want to impersonate',
        helperText:
          'Enter a Service Account email if you want to impersonate it when using this connection. Otherwise, leave it empty.'
      },
      billingProject: {
        title: 'Billing project',
        placeholder: 'Type to filter or select a billing project',
        help: 'Select a billing project where CARTO can run queries using your service account.',
        help_oauth: 'Select a billing project where CARTO can run queries using your credentials.'
      }
    },
    title: 'Connect to {provider}',
    subtitle: 'Your {provider} credentials',
    cancel: 'Cancel',
    connect: 'Connect',
    sslLabel: 'Use SSL to encrypt the connection',
    passwordPlaceholderEdit: '••••••••••••••',
    helpTitle: 'Need help?',
    ipWhitelistingTitle: 'IP Whitelisting',
    ipWhitelistingLink: 'IP Whitelisting documentation',
    ipWhitelistingDescription:
      'CARTO uses a set of static IPs to connect to your data. These can be whitelisted as needed:',
    helpDescription: `Please check our documentation if you are having trouble connecting to your data`,
    analyticsToolboxBanner: {
      title: 'CARTO Analytics Toolbox for {provider}',
      analyticsToolboxLink: 'Analytics Toolbox',
      guideLink: 'this guide',
      docLink: 'Check our documentation',
      documentationLink: 'documentation',
      content: {
        snowflake:
          'The {analyticsToolboxLink} provides geospatial functions to perform fundamental spatial operations, such as clustering and data enrichment, natively within the Snowflake environment.',
        bigquery:
          "The {analyticsToolboxLink} provides geospatial functions to perform fundamental spatial operations, such as clustering and data enrichment, natively within the BigQuery environment. Once you create a connection, your Service Account or Google user account will be granted permission to use all of the Analytics Toolbox's functions and procedures.Learn more in our {guideLink}.",
        redshift:
          'The {analyticsToolboxLink} provides geospatial functions to perform fundamental spatial operations, such as clustering and spatial indexing, natively within the Redshift environment. To install it, please follow the steps detailed in {guideLink}.',
        postgres:
          'The Analytics Toolbox provides additional geospatial functions to expand the possibilities of PostgreSQL + PostGIS, such as tileset generation functions or extensive support for quadbin as spatial index. Learn more in our {guideLink}.'
      },
      subContent: {
        redshift:
          'After installation, please ensure the user or role of your {provider} connection in CARTO has enough permissions to access it.'
      },
      installAvailable: {
        enabled:
          'The Analytics Toolbox is available as a Native App in the Snowflake Marketplace. Make sure to configure your Analytics Toolbox location in the Advanced options.',
        disabled:
          'Please contact your Snowflake administrator to install the Analytics Toolbox in your Snowflake account.'
      }
    },
    advanced: {
      title: 'Advanced options',
      analyticsToolboxDataLocationTitle: 'Analytics Toolbox & data location',
      databricksImportOptions: {
        title: 'Import options'
      },
      atLocation: {
        title: 'Analytics Toolbox location',
        description:
          'Indicate the location of the <a>Analytics Toolbox for {provider}</a>. This setting will be observed by Builder, Workflows and Data Explorer to generate SQL queries that use Analytics Toolbox functions.'
      },
      doLocation: {
        title: 'Data Observatory location',
        description:
          'Indicate the location of your custom <a>Data Observatory subscriptions</a>. This setting will be observed by Data Explorer, Workflows and Enrichment to access your data subscriptions.'
      },
      alert:
        'When using Viewer Credentials, this location is given a suffix like carto_temp_user and is created on demand for each user.',
      tempLocations: {
        title: 'CARTO temp. location',
        descriptionBigQuery:
          'CARTO requires a location to store <a>temporary tables</a> in your data warehouse. If you prefer to override the default <code>carto_temp</code> dataset, specify a valid and accesible <code>project.dataset</code> location. If the dataset does not exist yet, it will be created automatically.',
        descriptionGeneric:
          'CARTO requires a location to store <a>temporary tables</a> in your data warehouse. If you prefer to override the default <code>carto_temp</code> schema, specify a valid and accessible <code>database.schema</code>. If the schema does not exist yet, it will be created automatically.'
      },
      workspaceLocations: {
        title: 'CARTO Workspace location',
        descriptionBigQuery:
          'CARTO requires a workspace location to store workspace tables in your data warehouse. If you prefer to override the default <code>carto_workspace</code> dataset, specify a valid and accesible <code>project.dataset</code> location. If the dataset does not exist yet, it will be created automatically.',
        descriptionGeneric:
          'CARTO requires a workspace location to store non-temporary resources like imported files and stored procedures. If you prefer to override the default <code>carto_workspace</code> schema, enter a valid and accessible <code>database.schema</code>. If it doesn’t exist, it will be created automatically.'
      },
      extensionsLocations: {
        title: 'CARTO Extensions location',
        descriptionBigQuery:
          'CARTO uses this location to store shared Extension Package resources, including procedures and metadata. If you prefer to override the default <code>carto_extensions</code> dataset, enter a valid <code>project.dataset</code> location. If it doesn’t exist, it will be created automatically.',
        descriptionGeneric:
          'CARTO uses this location to store shared Extension Package resources, including procedures and metadata. If you prefer to override the default <code>carto_extensions</code> schema, enter a valid <code>database.schema</code>. If it doesn’t exist, it will be created automatically.'
      },
      developerOptions: {
        title: 'CARTO for Developers options',
        namedSourcesOnly: {
          title: 'Restrict this connection to only use Named Sources',
          description:
            'This setting will prevent the usage of SQL queries that have not been registered as <link>Named Sources</link>. Please note that this setting is aimed exclusively towards enforcing additional security in applications built with CARTO for Developers. Enabling it will cause this connection to stop working in Data Explorer, Builder and Workflows.'
        }
      },
      queryConcurrencyControl: {
        optionsTitle: 'Query management options',
        helperText:
          'These settings control concurrency and execution time of queries executed by CARTO. Set limits on the number of simultaneous queries and specify a maximum execution duration to optimize performance and resource usage on your data warehouse.',
        maxConcurrentQueries: {
          label: 'Max number of concurrent queries',
          placeHolder: '{default}',
          invalidMessage: 'It must be an integer between {min} and {max}'
        },
        queryTimeoutS: {
          label: 'Max query timeout',
          invalidMessage: 'It must be an integer between {min} and {max}',
          units: 'sec'
        }
      },
      dataTransferVersionInfo: {
        title: 'Data Transfer Version info',
        description:
          'CARTO Scheduling API in BigQuery OAuth connections requires to <a>generate a version info code</a>. This operation is required only once per connection.'
      }
    }
  },
  sharingDialog: {
    viewerCredentialsAlert: 'This connection will require viewers to provide their own credentials.',
    restrictedDescription: 'Only people you add can use it',
    organizationDescription: 'Anyone in {orgName} can use it',
    whoCanUseLabel: 'Who can use this connection',
    footerStatic:
      'Sharing this connection allows other CARTO users to access resources using the identity configured in the connection. {learnMore}',
    footerViewerCredentials:
      'Anyone you share this connection with will need to authenticate using their individual {provider} credentials. {learnMore}',
    footerLearnMore: 'Learn more.'
  },
  shareDialog: {
    confirm: 'Confirm',
    unsharingTitle: 'Do you want to change this connection to private?',
    sharingNotice: "By sharing this connection you're also sharing the permissions it might have.",
    unsharingWarning:
      'Turning this shared connection to private mode will break the data sources added by other users, affecting their maps.',
    disabledEntireOrganization:
      "You can't share this connection. For more information, please contact the organization Admin.",
    requiresViewerCredential: {
      switchLabel: "Requires viewer's credentials",
      hint: 'Anyone using this connection will need to enter their own connection credentials, except in public maps. <docLink>More info</docLink>',
      alertInfo: 'This connection will require viewers to provide their own credentials.',
      disablingViewerCredentialsTitle: "Do you want to disable viewer's credentials?",
      disablingViewerCredentials:
        "Disabling viewer's credentials will break the data sources added by other users, affecting their maps."
    },
    shareWithGroups: {
      notAvailable:
        "This connection is shared with all users in your organization. If you're interested in sharing with certain users or groups, <link>let us know</link>."
    },
    viewerCredentials: {
      disabledBigquery: 'BigQuery OAuth connections can only be shared by requesting the credentials of each user',
      disabledBigqueryWif:
        'Workload Identity Federation connections can only be shared by requesting the credentials of each user.',
      disabledServiceAccountSnowflake:
        'Snowflake connections using a Service Account are not compatible with requiring viewer credentials.',
      disabledKeyPairSnowflake:
        'Snowflake connections using a Key Pair are not compatible with requiring viewer credentials.',
      disabledSnowflake: 'Snowflake OAuth connections can only be shared by requesting the credentials of each user',
      disabledDatabricksU2M:
        'Databricks OAuth U2M connections can only be shared by requesting the credentials of each user.',
      disabledDatabricksM2M: 'Databricks OAuth M2M connections are not compatible with requiring viewer credentials.',
      disabledDatabricksRest: 'Databricks connections using Personal Access Tokens cannot require viewer credentials'
    },
    notShared: 'The connection has not yet been shared with the selected groups',
    notSharedDescription: 'If you close the dialog now, the connection will keep the current permission level.'
  },
  dataExplorer: {
    missingCredentials:
      "You don't have credentials to access this connection. Please add your credentials to access the data.",
    enterCredentials: 'Enter credentials'
  },
  credentialsDialog: {
    title: 'Credentials needed',
    promptConnection: 'This connection requires you to provide credentials to access the data:',
    cannotAccess: 'You cannot access this {entity}. Viewer credentials are required.',
    promptEntity: 'Some data sources of this {entity} require you to provide credentials to access the data:',
    databricks: {
      tokenLabel: 'Your Databricks Personal Access Token',
      placeholder: 'Copy and paste your Databricks Personal Access Token',
      helper: 'Learn how to get your Databricks Personal Access Token <link>here</link>.'
    },
    delete: {
      title: 'Remove my credentials',
      question: 'Are you sure you want to remove your credentials from Connection {connectionName}?',
      info: 'You can always add your credentials again when opening maps or workflows that use this connection.',
      questionMultiple: 'Are you sure you want to remove your credentials from the connections used in this map?',
      error: 'Error deleting your credentials for the connection {connectionName}:',
      actionButton: 'Yes, remove'
    },
    addCredentials: 'Add my credentials',
    accessDeniedError: `We couldn't authenticate using this token, please review and try again.`,
    cdwCredentialsProvisioning:
      'Your CARTO Data Warehouse credentials are still being provisioned. Please try again shortly.'
  },
  connectionsNewButton: {
    tooltip:
      'There is no data warehouse provider available for this organization. If you have any questions, please contact the organization Admin.'
  },
  brokenConnection: {
    edit: 'Edit connection',
    contactOwner: 'Contact {owner} to fix this connection.',
    contactOwnerGeneric: 'Contact the connection owner to fix it.'
  },
  authTypes: {
    service_account: 'Service Account',
    oauth: 'OAuth',
    workload_identity: 'Workload Identity Federation',
    user_password: 'Username/Password',
    snowflake_account: 'Username/Password',
    oauth_token: 'OAuth',
    key_pair: 'Key Pair',
    rest: 'Personal Access Token',
    oauth_u2m: 'OAuth U2M',
    oauth_m2m: 'OAuth M2M'
  }
}
